"use strict";

const idlUtils = require("../generated/utils");

exports.implementation = class PluginArray {
  refresh() {}

  get length() {
    return 0;
  }

  item() {
    return null;
  }

  namedItem() {
    return null;
  }

  get [idlUtils.supportedPropertyIndices]() {
    return [];
  }

  get [idlUtils.supportedPropertyNames]() {
    return [];
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/navigator/PluginArray-impl.js
// module id = S6Tg
// module chunks = 0